import { render, staticRenderFns } from "./editPaxelMarketBasicService.vue?vue&type=template&id=bdbdcd02&"
import script from "./editPaxelMarketBasicService.vue?vue&type=script&lang=js&"
export * from "./editPaxelMarketBasicService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports